const data = {
  title: "Floor 1-5",
  musicTrack: "MUSIC_WORLD1",
  theme: "BLUE",
  tilesWidth: 12,
  tilesHeight: 6,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 5,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 11,
      y: 2,
    },
    {
      type: "WALL",
      x: 4,
      y: 3,
    },
    {
      type: "WALL",
      x: 4,
      y: 2,
    },
    {
      type: "WALL",
      x: 4,
      y: 5,
    },
    {
      type: "WALL",
      x: 4,
      y: 6,
    },
    {
      type: "WALL",
      x: 6,
      y: 4,
    },
    {
      type: "WALL",
      x: 6,
      y: 3,
    },
    {
      type: "WALL",
      x: 9,
      y: 3,
    },
    {
      type: "WALL",
      x: 9,
      y: 4,
    },
    {
      type: "WALL",
      x: 9,
      y: 5,
    },
    {
      type: "WALL",
      x: 9,
      y: 1,
    },
    {
      type: "WALL",
      x: 7,
      y: 6,
    },
    {
      type: "WALL",
      x: 6,
      y: 1,
    },
    {
      type: "WALL",
      x: 7,
      y: 1,
    },
    {
      type: "WALL",
      x: 6,
      y: 6,
    },
    {
      type: "KEY",
      x: 8,
      y: 3,
      color: "BLUE",
    },
    {
      type: "LOCK",
      x: 9,
      y: 6,
      color: "GREEN",
    },
    {
      type: "LOCK",
      x: 6,
      y: 5,
      color: "BLUE",
    },
    {
      type: "WALL",
      x: 9,
      y: 2,
    },
    {
      type: "WALL",
      x: 8,
      y: 4,
    },
    {
      type: "KEY",
      x: 2,
      y: 2,
      color: "GREEN",
    },
    {
      type: "LOCK",
      x: 4,
      y: 1,
      color: "GREEN",
    },
    {
      type: "LOCK",
      x: 6,
      y: 2,
      color: "GREEN",
    },
    {
      type: "CHIP",
      x: 8,
      y: 1,
    },
    {
      type: "CHIP",
      x: 5,
      y: 6,
    },
    {
      type: "WALL",
      x: 7,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 4,
    },
  ],
};

export default data;
